// extracted by mini-css-extract-plugin
export default {"container":"changeAllStudentsPayment_container__DoScX","button":"changeAllStudentsPayment_button__nZeIK","change":"changeAllStudentsPayment_change__TLxQP"};